import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ProjectSettingsAccessTokensLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./access-tokens'),
});
